<!--小程序 首页推荐品牌 -->
<template>
  <div class="page">
    <!-- 搜索 -->
    <el-form
      v-if="isSearch"
      :model="queryForm"
      ref="form"
      label-width="80px"
      :inline="true"
      size="small"
      class="query-form"
      @submit.native.prevent
    >
      <!-- <el-form-item label="搜索">
        <el-input v-model="queryForm.brandName"></el-input>
      </el-form-item> -->
      <!-- <el-form-item>
        <el-button
          size="small"
          type="primary"
          icon="el-icon-search"
          @click="getBrandList"
        >查询</el-button>
        <el-button
          size="small"
          icon="el-icon-refresh"
          @click="resetQueryFrom"
        >重置</el-button>
      </el-form-item> -->
    </el-form>
    <div class="page-content">
      <!-- <div class="page-tool-bar">
        <div class="el-btn-group">
          <el-button
            type="primary"
            size="small"
            icon="el-icon-plus"
            :disabled="multipleSelection.length > 0"
            @click="addShopBrand(1)"
          >新建</el-button>
          <el-button
            type="danger"
            plain
            size="small"
            icon="el-icon-delete"
            :disabled="multipleSelection.length <= 0"
            @click="deleteShopBrand(null)"
          >删除</el-button>
        </div>

        <div class="icon-group">
          <span
            title="搜索"
            class="icon-box"
            @click="search"
          >
            <Icon color="#606266">
              <Search />
            </Icon>
          </span>
          <span
            class="icon-box"
            @click="refreshShopBrandList"
          >
            <Icon color="#606266">
              <Refresh />
            </Icon>
          </span>
        </div>
      </div> -->
      <!-- 列表数据 -->
      <el-table
        v-loading="loading"
        :data="shopBrandList"
        row-key="id"
        @selection-change="handleSelectionChange"
        size="small"
        border
      >
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="userName"
          label="账号"
          min-width="20%"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="userMobile"
          label="手机号码"
          min-width="20%"
        > </el-table-column>
          <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="storeName"
          label="门店名称"
          min-width="20%"
        >
       </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="userNickname"
          label="昵称"
          min-width="20%"
        >
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="fansType"
          label="组织类型"
          min-width="10%"
        >
        <template slot-scope="scope">
           <div>
              {{ scope.row.fansType == 1 ? '粉丝' : '门店' }}
           </div>
        </template>
       </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="isHaveIncome"
          label="是否有消费凭证"
          min-width="10%"
        >
        <template slot-scope="scope">
           <div>
              {{ scope.row.isHaveIncome == 1 ? '有' : '否' }}
           </div>
        </template>
       </el-table-column>
      
        <!-- <el-table-column
          align="center"
          label="操作"q
          min-width="20%"
        >
          <template slot-scope="scop">
            <div class="operation">
              <div @click="checkShopBrand(scop.row)">
                <Icon size="16">
                  <Eye24Regular />
                </Icon>
                <span class="operation-label">查看</span>
              </div>
              <div @click="editShopBrand(scop.row)">
                <Icon size="16">
                  <Edit24Regular />
                </Icon>
                <span class="operation-label">修改</span>
              </div>
             <div @click="deleteShopBrand(scop.row.id)">
                <Icon
                  size="16"
                  style="color: red"
                >
                  <Delete24Regular />
                </Icon>
                <span
                  class="operation-label"
                  style="color: red"
                >删除</span>
              </div>
           </div>
          </template>
        </el-table-column> -->
      </el-table>
      <div class="pagination-box">
        <el-pagination
          @size-change="sizeChange"
          @current-change="currentChange"
          :current-page.sync="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalNum"
          background
          :pager-count="7"
        >
        </el-pagination>
      </div>
      <!-- 新增/查看/修改信息 -->
      <!-- <el-dialog
        :title="shopBrandStates[shopBrandState]"
        :visible.sync="showDialog"
        width="400px"
        @close="closeDialog"
        append-to-body
      >
        <div>
          <el-form
            :model="shopBrand"
            ref="shopBrandForm"
            :rules="rules"
            label-width="80px"
            :inline="true"
            size="small"
          >
           
             <el-form-item  label='品牌名称' prop="brandName">
                  <el-select
                    v-model="shopBrand.brandName"
                    filterable
                    remote
                    placeholder="查询品牌"
                    style="width: 240px"
                    :remote-method="getBrandId"
                    @change="searchBrandChange(brandQueryList,shopBrand.brandName)"
                  >
                    <el-option
                      v-for="item in brandQueryList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
            </el-form-item>
            <el-form-item
              label="结束时间"
              prop="effectEndTime"
              v-if="shopBrandState == 'check'"
            >
              <el-input
                size="small"
                style="width: 180px; color: #181818;"
                v-model="shopBrand.effectEndTime"
                :disabled="shopBrandState == 'check'"
              ></el-input>
            </el-form-item>
            <el-form-item label="结束时间"  v-else>
                <el-date-picker
                    v-model="shopBrand.effectEndTime"
                    style="width: 200px"
                    type="datetime"
                    placeholder="Pick a Date"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    range-separator="-"
                  />
            </el-form-item>
             <div v-if="shopBrandState == 'edit'">
                  <el-form-item label="排序"  >
                      <el-input v-model="shopBrand.sort" type="number" @change="handleChange" />
                  </el-form-item>
             </div>

          </el-form>
        </div>
        <div
          slot="footer"
          class="flex justify-end"
        >
          <el-button @click="closeDialog">关闭</el-button>
          <el-button
            type="primary"
            @click="submitForm"
            v-if="shopBrandState != 'check'"
          >确定</el-button>
        </div>
      </el-dialog> -->
    </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { get, post, deleteFun, upload } from '@/utils/request.js';
export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
    },
    watch: {
        checkState(val) {
            if (val == 'check') {
                this.resetShopBrandList();
                this.getBrandList(this.queryForm);
                this.$emit('resetCheckState');
            } else if (val == 'reset') {
                this.resetShopBrandList();
                this.getBrandList();
                this.$emit('resetCheckState');
            }
        }
    },
    props: {
        userId: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            queryForm: {
                brandName: '',
            },
            goodsTitle: '商品列表',
            goodsBrandList: {},
            loading: false,
            showDialog: false,
            isImportDate: false,
            isSearch: false,
            isDeleteFlagEnabled:true,
            goodsShowDialog: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            currentShopBrandId: '',
            shopBrandState: 'add',
            shopBrandStates: {
                add: '新建品牌',
                check: '查看品牌',
                edit: '修改品牌'
            },
            goodsState: 'add',
            goods: {
                add: '添加商品',
                check: '查看商品',
                edit: '修改商品'
            },
            multipleSelection: [],
            shopBrandList: [],//列表数据
            shopBrand: {
                id:'',//首页品牌推荐ID标识
                brandId:'',//品牌ID
                brandName: '',//品牌名称
                brandLogo: '',//品牌Logo
                effectEndTime:'',//生效截止时间
                ifEffect:'', //标记是否开启
                sort:"",//排序
            },
            btnLoading: false,
            status: '', //1 :用户 2 ：职位
            rules: {
                brandName: [{ required: true, message: '品牌名称不能为空', trigger: 'blur' }],
                brandLogo: [{ required: true, message: '品牌Logo不能为空', trigger: 'blur' }],
                effectEndTime: [{ required: true, message: '结束时间不能为空', trigger: 'blur' }],
            },
            srcList:[''],//大图预览
            brandQueryList: [],
        };
    },
    created() {
        this.getBrandList();
    },
    methods: {
      handleChange(value) {
            this.shopBrand.sort = value;
        },  
        search() {
            this.isSearch = !this.isSearch;
        },
        resetShopBrandList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.shopBrandList = [];
        },

        resetDialog() {
            this.shopBrandState = 'add';
            this.showDialog = false;
            this.shopBrand = {
                brandName: '',
                brandLogo: '',
            };
            this.getBrandList();
        },
        closeDialog() {
            this.resetDialog();
            this.$refs.shopBrandForm.resetFields();
        },
        //启用禁用
        toggleDeleteFlag(row) {

            this.shopBrand = {
                id: row.id,
                brandId: row.brandId,
                brandName: row.brandName,
                effectEndTime: row.effectEndTime,
                ifEffect: row.ifEffect == 0 ? 1 : 0,
                sort: row.sort,
            };
            // 发送更新请求
            post(`/shop/productBrandTime/update`, this.shopBrand).then((res) => {
                if (res.success) {
                      this.$message({
                          message: res.msg,
                          type: 'success',
                          duration: 2000
                      });
                      this.resetShopBrandList();
                      this.closeDialog();
                  }
              });
          },
        //获取品牌id
        getBrandId(brandName) {
            get(`/shop/productbrand/findList`, { brandName: brandName, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                if (res.success) {
                   this.brandQueryList = res.page.list.map(item => ({
                       value: item.id,
                       label: item.brandName,
                        ifEffect: item.deleteFlag
                   }));
                  //  if(res.page.list[0].deleteFlag == 0){
                  //      this.shopBrand.brandId = res.page.list[0].id;
                  //  }else{
                  //      this.shopBrand.brandId = '';
                  //  }
                }
            });
        },
            // 品牌选择后的回调
            searchBrandChange(list,value) {
                list.forEach((item) => {
                    if (item.value == value && item.ifEffect == 0) {
                        this.shopBrand.brandId = value;
                        this.shopBrand.brandName = item.label;
                    } 
                });
            
            },
        submitForm() {
            if (this.shopBrandState == 'add') {
                this.$refs.shopBrandForm.validate((valid) => {
                    if (valid) {
                      // 新增接口
                      this.shopBrand.ifEffect = 0;
                        post(`/shop/productBrandTime/insert`, {
                            ...this.shopBrand
                        }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetShopBrandList();
                                this.closeDialog();
                            }
                        });
                    }
                });
            } else if (this.shopBrandState == 'edit') {
                this.$refs.shopBrandForm.validate((valid) => {
                    if (valid) {
                      //  修改接口
                        post(`/shop/productBrandTime/update`,this.shopBrand ).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetShopBrandList();
                                this.closeDialog();
                            }
                        });
                    }
                });
            }
        },

        updateSrcList(src){
            this.srcList[0] = src
        },
       //  添加
        addShopBrand(value) {
            this.showDialog = true;
            this.status = value;
            this.shopBrandState = 'add';
        },
        // 查看
        checkShopBrand(row) {
           this.shopBrand = {
                id:row.id,
                brandId:row.brandId,
                brandName: row.brandName,
                effectEndTime:row.effectEndTime,
            };
            this.showDialog = true;
            this.shopBrandState = 'check';
        },
        // 修改
        editShopBrand(row) {
            this.shopBrand = {
                id:row.id,
                brandId:row.brandId,
                brandName: row.brandName,
                effectEndTime:row.effectEndTime,
                ifEffect:row.deleteFlag,
                sort:row.sort,  
            };
            this.showDialog = true;
            this.shopBrandState = 'edit';
        },
        // 删除
        deleteShopBrand(shopBrandId) {

            let idList = this.multipleSelection.map((shopBrand) => shopBrand.id).join(',');
              if (shopBrandId) {
                  if (idList) {
                      idList += `,${shopBrandId}`; 
                  } else {
                      idList = shopBrandId; 
                  }
              }
            this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    deleteFun(`/shop/productBrandTime/delete`, { idList }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.resetShopBrandList();
                            this.getBrandList();
                        }
                    });
                })
                .catch(() => {});
        },
        refreshShopBrandList() {
            this.resetShopBrandList();
            this.getBrandList();
        },
        // 列表数据请求
        getBrandList() {
            this.loading = true;
            get(`/tianyilife/user/queryFans`, {
                userId:this.userId,
                pageNum: this.currentPage,
                pageSize: this.pageSize
            }).then((res) => {
                this.loading = false;
                if (res.success) {
                    this.shopBrandList = res.fans.list;
                    this.totalNum = res.fans.total;
                }
            });
        },
        resetQueryFrom() {
            this.queryForm.brandName = '';
            this.getBrandList();
        },
        getShopBrandById() {
            get(`/shop/productbrand/get`, { id: this.currentShopBrandId }).then((res) => {
                if (res.success) {
                    this.shopBrand = { ...this.shopBrand, ...res.shopBrand };
                }
            });
        },
        
        handleSelectionChange(value) {
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
            this.getBrandList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getBrandList();
        },
       
      
    }
};
</script>

<style lang="scss" scoped>
    ::v-deep .is-scrolling-none{
         min-height: calc(50vh - 100px) !important;
    }


::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
::v-deep .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 178px;
    height: 178px;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 178px;
    text-align: center;
}
.avatar {
    width: 178px;
    height: 178px;
    display: block;
}
.logo-img {
    margin-left: 50%;
    transform: translate(-50%, 0);
}
</style>
